import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';

import { Creators as PaymentsActions, Types as PaymentsTypes } from 'store/ducks/payments';

function* getPaymentRequest(action) {
  try {
    const { id } = action.payload;
    const url = `store/v2/payment_methods/${id}`;
    const response = yield call(api.get, url);

    yield put(PaymentsActions.getPaymentSuccess(response.data));
  } catch (error) {
    yield put(PaymentsActions.getPaymentFailure());
  }
}

function* getPaymentsRequest(action) {
  try {
    const { page } = action.payload;
    const url = `store/v2/payment_methods?page=${page}&per=25`;
    const response = yield call(api.get, url);

    yield put(PaymentsActions.getPaymentsSuccess(response.data));
  } catch (error) {
    yield put(PaymentsActions.getPaymentsFailure());
  }
}

function* createPaymentRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'store/v2/payment_methods';
    yield call(api.post, url, data);

    yield put(push('/points/payments'));
    yield call(swal, 'Adicionado', 'Novo método de pagamento adicionado', 'success');
    yield put(PaymentsActions.createPaymentSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível criar o método de pagamento.', 'error');
    yield put(PaymentsActions.createPaymentFailure());
  }
}

function* updatePaymentRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `store/v2/payment_methods/${id}`;
    yield call(api.put, url, data);

    yield put(push('/points/payments'));
    yield call(swal, 'Atualizado', 'Método de pagamento atualizado', 'success');
    yield put(PaymentsActions.updatePaymentSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar o método de pagamento.', 'error');
    yield put(PaymentsActions.updatePaymentFailure());
  }
}

function* deletePaymentRequest(action) {
  try {
    const { id } = action.payload;
    const url = `store/v2/payment_methods/${id}`;
    yield call(api.delete, url);

    yield put(push('/points/payments'));
    yield call(swal, 'Deletado', 'Método de pagamento deletado', 'success');
    yield put(PaymentsActions.deletePaymentSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao deletar', 'Não foi possível deletar o método de pagamento.', 'error');
    yield put(PaymentsActions.deletePaymentFailure());
  }
}

export default function* sagaPayments() {
  yield takeLatest(PaymentsTypes.GET_REQUEST, getPaymentRequest);
  yield takeLatest(PaymentsTypes.GET_LIST_REQUEST, getPaymentsRequest);
  yield takeLatest(PaymentsTypes.CREATE_REQUEST, createPaymentRequest);
  yield takeLatest(PaymentsTypes.UPDATE_REQUEST, updatePaymentRequest);
  yield takeLatest(PaymentsTypes.DELETE_REQUEST, deletePaymentRequest);
}
